import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "@/app/hooks";
import { isPreEpMember, PRE_EP_HOME } from "../../config/preEpStage";

/** Pages a Pre-EP member may use: the Pre-EP pages and event checkout. */
const ALLOWED = [
  /^\/pre-ep(\/|$)/,
  /^\/event-registration\/events\/[^/]+\/(register|confirmation)\/?$/,
];

export const isAllowedForPreEpMember = (path: string): boolean =>
  ALLOWED.some((pattern) => pattern.test(path));

/**
 * A Pre-EP member's Hub+ is the full-screen Pre-EP pages: any other page
 * sends them there. Everyone else passes straight through.
 */
const PreEpGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const settings = useAppSelector(
    (state) => state.userAppSettings.userAppSettings,
  );

  if (isPreEpMember(settings) && !isAllowedForPreEpMember(location.pathname)) {
    return <Navigate replace to={PRE_EP_HOME} />;
  }

  return <>{children}</>;
};

export default PreEpGate;
